/**
 * List of known extension keys on the content link item
 */ export var ContentLinkExtensionKeys = /*#__PURE__*/ function(ContentLinkExtensionKeys) {
    /** Service understood legacy data from basic plans */ ContentLinkExtensionKeys["legacyData"] = "LegacyData";
    /**
     * A client-only extension key for Planner Link (PLink) data.
     * Deliberately NOT nested inside `LegacyData` - the service special-cases that key and only
     * round-trips its own `type`/`previewPriority` fields, silently dropping anything else placed
     * inside it. A distinct top-level key flows through the generic extension-field pipeline instead,
     * which genuinely persists and returns arbitrary client schemas.
     * TODO: Remove this client-only extension key once service work is checked in.
     */ ContentLinkExtensionKeys["plinkData"] = "PLinkData";
    return ContentLinkExtensionKeys;
}({});
